import { FaPaperclip } from "react-icons/fa";
import DropdownItemBase from "./DropdownItemBase";
import { useTranslation } from "react-i18next";

const DropdownItemArquivoAgendamento = ({ notif, onClick }) => {
    const { t } = useTranslation(['layout']);
    const info = notif.atendimento_info;
    if (!info) return null;

    let dataFormatada = notif.data_criacao || "";
    if (dataFormatada && !dataFormatada.includes('/')) {
            try {
                dataFormatada = new Date(dataFormatada).toLocaleString("pt-BR");
            } catch (e) {}
    }

    return (
        <DropdownItemBase
            icon={<FaPaperclip />}
            text="text-info"
            titulo={t('layout:notificationItems.file.title')}
            descricao={
                <>
                    Paciente: <strong>{info.beneficiario_nome}</strong>
                </>
            }
            subDescricao={`${t('layout:notificationItems.label.program')}: ${info.programa_nome}`}
            dataFormatada={dataFormatada}
            onClick={() => onClick(notif)}
        />
    );
};

export default DropdownItemArquivoAgendamento;
